<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-xs-12 col-md-12">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">通知方式綁定列表</h3>
          </div>
          <div class="box-body">
            <line-notify-table />
          </div>
          <div class="box-header">
            <h3 class="box-title">門市綁定列表</h3>
          </div>
          <div class="box-body">
            <store-notify-table />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import $ from 'jquery'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import lineNotifyTableTemp from './Temp/LineNotifyTableTemp.vue'
import storeNotifyTableTemp from './Temp/StoreNotifyTableTemp.vue'
import { mapActions } from 'vuex'
export default {
  name: 'Tables',
  data () {
    return {
      tableIndex: 1
    }
  },
  mounted () {
    this.$nextTick(() => {
      $('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      })
    })
  },
  methods: {
    ...mapActions(['setSelManagerId']),
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    }
  },
  components: {
    'line-notify-table': lineNotifyTableTemp,
    'store-notify-table': storeNotifyTableTemp
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    }
  },
  beforeRouteLeave (to, from, next) {
    this.setSelManagerId(0)
    next()
  }
}
</script>



// WEBPACK FOOTER //
// LineNotifyTable.vue?5ff43d7c